<template>
    <v-flex xs12 md10 offset-md1 >
        <v-toolbar color="blue darken-1" dark>
            <v-toolbar-title>Move To Group</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-card-title>
                <v-select
                        v-model="select"
                        :items="items"
                        item-text="groupValue"
                        item-value="groupKey"
                ></v-select>
                <v-btn color="default" @click="moveDialog = true">Move Device To Group</v-btn>
            </v-card-title>
        </v-card>
        <v-dialog v-model="moveDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Move This Device?</v-card-title>
                <v-card-text>Please confirm that you want to move this device to a new Group.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="proceed">Yes, move</v-btn>
                    <v-btn color="green darken-1" flat @click.native="moveDialog = false">No, cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>

</template>

<script>
    import {mapGetters} from 'vuex'

    const fb = require('../firebase')
    export default {
        name: 'DeviceMoveGroup',
        props: ['id'],
        data() {
            return {
                group: {},
                groupId: '',
                newGroupId: '',
                moveDialog: false
            }
        },
        computed: {
            ...mapGetters(['getGroupList']),
            items: function () {
                let arr = []
                this.getGroupList.forEach((doc) => {
                    arr.push({groupKey: doc.id, groupValue: doc.name})
                })
                return arr
            },
            select: {
                get() {
                    if (this.group !== undefined) {
                        return {groupKey: this.groupId, groupValue: this.group.name}
                    } else {
                        return {groupKey: '', groupValue: ''}
                    }
                },
                set(val) {
                    this.newGroupId = val
                }
            }
        },
        mounted() {
            fb.groupsCollection
                .where('devices', 'array-contains', this.id)
                .get()
                .then((docs) => {
                    this.$store.commit('hideProgress')
                    docs.forEach((doc) => {
                        this.groupId = doc.id
                        this.group = doc.data()
                    })
                })
        },
        methods: {
            removeItemFromArray: function (val, arr) {
                let newItems = []
                arr.forEach(function (item) {
                    if (val !== item) {
                        newItems.push(item)
                    }
                })
                return newItems
            },
            proceed: function () {
                this.moveDialog = false
                if (this.newGroupId !== '' && this.newGroupId !== this.groupId) {
                    let thisDevice = this.id
                    let oldGroupId = this.groupId
                    let newGroupId = this.newGroupId

                    // remove from old group
                    fb.groupsCollection
                        .doc(oldGroupId)
                        .get()
                        .then((doc) => {
                            let newArray = this.removeItemFromArray(thisDevice, doc.data().devices)
                            fb.groupsCollection
                                .doc(oldGroupId)
                                .set({devices: newArray}, {merge: true})
                                .then(() => {
                                    fb.groupsCollection
                                        .doc(newGroupId)
                                        .get()
                                        .then((doc) => {
                                            let newArray = doc.data().devices
                                            newArray.push(thisDevice)
                                            fb.groupsCollection
                                                .doc(newGroupId)
                                                .set({devices: newArray}, {merge: true})
                                                .then(() => {
                                                    this.$router.push('/group/' + newGroupId)
                                                })
                                        })
                                })
                        })
                } else {
                    this.$store.commit('showSnack', 'Please select a new Group to move this device to.')
                }
            }
        }
    }
</script>

<style scoped>

</style>
